import React, { useEffect, useState } from 'react';

function Layout({
    children,
    className = '',
    isSelectedPage,
    adjustedZIndex = 'z-30',
    adjustedWidth = 'w-full',
    adjustedHeight = 'h-full',
}) {
    const [fade, setFade] = useState(false);
    const [zIndex, setZIndex] = useState('-z-10');

    useEffect(() => {
        let timeout;

        if (isSelectedPage) {
            setZIndex(adjustedZIndex);
            timeout = setTimeout(() => setFade(true), 50);
        } else {
            setFade(false);
            timeout = setTimeout(() => setZIndex('-z-10'), 300);
        }

        return () => clearTimeout(timeout);
    }, [isSelectedPage, adjustedZIndex]);

    return (
        <div
            className={`absolute ${adjustedWidth} ${adjustedHeight} flex-1
                transition-opacity duration-300 ease-in-out
                ${fade ? 'opacity-100' : 'opacity-0'}
                ${zIndex} ${className}`}
        >
            {children}
        </div>
    );
}

export default Layout;
